import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../../api";
import { formatDate, getUpdateOwnerName, isNullOrUndefined } from "../../../utils/formatting";
import { RouteComponentProps } from "react-router-dom";
import { PremisesType } from "../../../models/Customer/Premises";
import {
  backToCaseAsset,
  caseData,
  userChosentenancyGroup,
} from "../../../ducks/redux/actions/userChoices";
import { BackValue } from "../../../models/shared/Enum";
import { USERCHOSEN_PROPERTY_ID } from "../../../ducks/redux/actionTypes";
import { comingFromCase, storeAPIErrors } from "../../../ducks/redux/actions/FinancialReferral";
import ServiceRequestImg from '../../../assets/icons/service-requests-icon.png';
import '../../../utils/commonCss/icons.css'
import useBackToTop from "../../BackToTop/useBackToTop";
import { PermissionsList } from "../../../models/Permissions";
import ErrorComponent from "../../APIErrorComponent/ErrorComponent";
import { addAPIError, removeAPIError } from "../../../utils/translation/helper";
import { getAssetsById, getCasesList, getCustomer} from "../../APIErrorComponent/APIConstantName";
import KebabMenu from "../../KebabMenu";


const Loader = React.lazy(() => import("react-loader-spinner"));

interface CaseCardProps extends RouteComponentProps<any> {
  errorFlag: boolean;
}

const CaseCard: React.FC<CaseCardProps> = (props) => {
  let status: any = {
    Active: 1,
    Resolved: 2,
    Cancelled: 3,
  };
  const caseCardData: any = [{createdDate:'-',caseSubTypeCategory:'-',status:'-'},{createdDate:'-',caseSubTypeCategory:'-',status:'-'}];
  let {errorFlag} = props;
  const[caseListApiFlag, setCaseListApiFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [caseSearchData, setCaseSearchData] = useState(caseCardData);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
  const assetDetails = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const isActiveTenancy = useSelector(
    (state: any) => state?.userChoicesReducer?.isActiveTenancy
  );
  const backValue = useSelector(
    (state: any) => state?.userChoicesReducer?.backValue
  );
  const customerId = useSelector(
    (state: any) => state?.userChoicesReducer?.custommerID
  );
  let assetStatus = useSelector(
    (state: any) => state?.userChoicesReducer?.assetDataStatus
  );
  let selectedTenanacy = useSelector(
    (state: any) => state?.addresses?.selectedTenancy
  );
  const eligibleSelectCustomer = useSelector(
    (state: any) => state?.caseCreationReducer?.eligibleSelectCustomer
  );
  const assetDataResponse = useSelector(
    (state: any) => state?.userChoicesReducer?.assetDataResponse
  );
  const customerResponse = useSelector(
    (state: any) => state?.addresses?.saveCustomerDetails
  );
  
  const caseTenancyIdentifier = useSelector(
    (state: any) => state?.caseCreationReducer?.caseTenancyId
  );

  const associatedAssets = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenAssociatedAssets
  );
  const {width = 0} = useBackToTop() || {};
  const [titleMessage, setTitleMessage] = useState("");
  let arrayErrorCode: string[] = [];
  let [errorMsgArray, seterrorMsgArray] = useState(arrayErrorCode);

  const [dropDown, setDropDown] = useState("none");

  const callcase360 = (caseSelectedData: any) => {
    dispatch(caseData(caseSelectedData));
    props.history.push("/Case360View");
  };

  const GetTitleMsg = (count: any) => {
    if (backValue === BackValue.Customer360View) {
      let message = t("CP048a");
      setTitleMessage(message.replace("{0}", count));
    } else if (backValue === BackValue.Asset360View) {
      let message = t("CP048c");
      setTitleMessage(message.replace("{0}", count));
    }
  };

 

  const getSearchApi = async (assetIDsAll: string, tenancyIdentifier: string, customerIdentifier: string) => {
    try {
      setIsLoading(true);
      const casequeryParams = {
        searchText: "",
        orderBy: "createdDate desc",
        status: "",
        limit: 2,
        skip: 0,
        defaultassocitaedAsset: assetIDsAll,
        CustomerIdentifiers: customerIdentifier,
        tenancyIdentifiers: tenancyIdentifier
      };
      const caseSearchResponse = await api.getCasesList(casequeryParams);
      dispatch(storeAPIErrors(removeAPIError(getCasesList, errors)));
      // === Sorting cases according to status ===
      const sortedData = caseSearchResponse.cases;
      sortedData.sort((a, b) => status[a.status] - status[b.status]);
    
      setCaseSearchData(sortedData);
      GetTitleMsg(caseSearchResponse["total-count"]);
      noCaseDataMsg();
    } catch (e) {
        console.error(e);
        dispatch(storeAPIErrors(addAPIError(getCasesList, errors)));
        setCaseListApiFlag(true)
        setCaseSearchData([{createdDate:'-',caseSubTypeCategory:'-',status:'-'},{createdDate:'-',caseSubTypeCategory:'-',status:'-'}]);
    } finally {
      setIsLoading(false);
    }
  };
  const dropDownFunction = () => {
    if (dropDown === "none") setDropDown("block");
    else setDropDown("none");
  };

  const handleCustomer360View = () => {
    if (associatedAssets?.length === 1) {
      props.history.push("/CaseAsset");
    } else if (associatedAssets?.length > 1) {
      props.history.push("/SelectTenancy");
    }
  };

  const getTenancyGroupForAsset = async (): Promise<string> => {
    let tenancyGroup = "ALL";
    if (
      !isNullOrUndefined(customerResponse) &&
      assetDataResponse?.assetType === "Property"
    ) {
      let id = customerResponse["customer-identifier"];
      if (id !== undefined) {
        const tenancyResponse = await api.getTenancies(id);
        tenancyGroup = tenancyResponse[0].tenancyGroup;
      }
    }
    return tenancyGroup;
  };

  const handleAssetTypeNavigation = (tenancyGroup: string) => {
    if (assetDataResponse?.assetType === "Property") {
      dispatch(userChosentenancyGroup(tenancyGroup));
      props.history.push("/CaseType");
    } else {
      dispatch(userChosentenancyGroup("All"));
      props.history.push("/CaseType");
    }
  };

  const handleAsset360View = async () => {
    if (selectedTenanacy === "Property" && eligibleSelectCustomer === true) {
      dispatch({
        type: USERCHOSEN_PROPERTY_ID,
        payload: assetDataResponse.id,
      });
      props.history.push("/SelectCustomer");
    } else {
      const tenancyGroup = await getTenancyGroupForAsset();
      handleAssetTypeNavigation(tenancyGroup);
    }
  };

  const callCaseHandler = async () => {
    dispatch(comingFromCase(true))
    backToCaseAsset(false);
    if (backValue === BackValue.Customer360View) {
      handleCustomer360View();
    } else if (backValue === BackValue.Asset360View) {
      await handleAsset360View();
    }
  };
  useEffect(() => {
    (async () => {
      try {
        
        if (backValue === BackValue.Asset360View) {
          if(assetDetails) {
            setIsLoading(true);
            const assetIDsAll = "assetIdentifiers=" + assetDetails?.id;
            getSearchApi(assetIDsAll,"", "");
          }
        } else if (backValue === BackValue.Customer360View) {
          if(caseTenancyIdentifier) {
            const assetIDsAll = "";
            getSearchApi(assetIDsAll, caseTenancyIdentifier, customerId);
          }
        }
      } catch (e) {
        console.error(e)
        setIsLoading(false);
      }
    })();
  }, [assetDetails, caseTenancyIdentifier]);

  function noCaseDataMsg() {
    const tempArray = t("CP048b").split("?");
    seterrorMsgArray(tempArray);
  }
      
  const callCaseListPage = () => {
      props.history.push("/CaseList");
  };
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  
  const createCaseStandard = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_case_standard );
  const viewServiceList = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.cases_list);
  return (
    <main>
      <div className="relative pb-16 border border-grey bg-white rounded-lg cust-card">
        {isLoading ? (
          <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
        ) : (
          <div data-testid="casesContainer">
            <div className="px-4 py-2 border-b border-grey bg-teal rounded-t-lg">
              <div className="flex flex-row d-flex bd-highlight items-center">
              <img src={ServiceRequestImg} className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt= "" />
                <h2 className="my-0 text-white bd-highlight"> {t("CP048")} </h2>
                {(isActiveTenancy && backValue === BackValue.Customer360View) ||
                (BackValue.Asset360View &&
                  ((selectedTenanacy === PremisesType.Property &&
                    (assetStatus === "OCCP" || assetStatus === "VOID")) ||
                    selectedTenanacy === PremisesType.Block ||
                    selectedTenanacy === PremisesType.DividedBlock||
                    selectedTenanacy === PremisesType.Estate)) ? (
                  <div className="menu-nav ms-auto bd-highlight">
                    <KebabMenu
                      onToggle={dropDownFunction}
                      isOpen={dropDown === "block"}
                      dropdownClassName="dropdown px-2 dropdown-margin py-2"
                      openClassName="block"
                      closedClassName="hidden"
                    >
                      <button type={undefined} data-testid="view_trans" onClick={callCaseHandler} className="text-black text-base global-txt dropdown-menu-button">
                         {createCaseStandard && t("CP104")}
                      </button>
                    </KebabMenu>
                  </div>
                ) : null}
              </div>
            </div>
            {caseSearchData?.length > 0 && (
              <div className="global-txt">
                <div className="text-dark flex justify-start">
                  <div className="py-2 px-4 global-txt">
                    {titleMessage}{" "}
                  </div>
                </div>
              </div>
            )}
            {!caseSearchData?.length && errorMsgArray.length>0? (
              <div>
                <div className="w-full test-base my-2 px-4 global-txt mt-3">
                  <b>{errorMsgArray[0]}</b>
                  <ul className="mt-2 ml-2">
                    <li className="listWithIndent"> {errorMsgArray[1]}</li><br/>
                    <li className="listWithIndent"> {errorMsgArray[2]}</li><br/>
                    <li className="listWithIndent"> {errorMsgArray[3]}</li>
                  </ul>
                </div>
              </div>
            ) : (
              caseSearchData.slice(0, 2).map((el: any) => (
                <div key={el.caseReferenceNumber} className="px-4 py-2">
                <div className="border border-grey rounded-lg bg-grey">
                  <div className=" bg-peach py-2 rounded-t-lg">
                    <div className={width<820?"py-1 px-4":"flex justify-between px-4"}>
                     
                      <b>{el.caseReferenceNumber?
                        (<button
                          type={undefined}
                          data-testid={
                            "CaseNumberLink" + el?.caseReferenceNumber
                          }
                        className="text-dark cursor-pointer global-txt underline-no-bg"
                        onKeyPress={() => callcase360(el)}  onClick={() => callcase360(el)}
                        >
                          <strong className="margin-left-reverse">{el.caseReferenceNumber}</strong>
                        </button>):<strong>-</strong>}</b>
                      
                      <div className="global-txt mt-2">
                        <strong>{el.caseSubType}</strong>
                      </div>
                    </div>
                  </div>

                  <div className="border-tint global-txt">
                    <div className="px-4 grid grid-cols-1 md:grid-cols-2">
                    <div className="py-2">
                      <div><b>{t("CP084")}</b></div>
                      <div className="global-txt">
                        {" "}
                        {el.caseSubTypeCategory}
                      </div>
                    </div>
                    <div className="py-2">
                      <div><b>{t("CP086")} </b></div>
                      <div> {el.status}</div>
                    </div>  
                    <div className="py-2">
                      <div><b>{t("CP082")} </b></div>
                      <div>{formatDate(el.createdDate)}</div>
                    </div>
                    
                    <div className="py-2">
                      <div><b>{t("CP085")}</b></div>
                      <div className="global-txt">
                           {getUpdateOwnerName(el?.owner?.name)}
                      </div>
                    </div>
                  
                    </div>
                  </div>
                </div>
                </div>
              ))
            )}
            {caseSearchData?.length > 0 && viewServiceList && !errorFlag && !caseListApiFlag ? (
                  <div className="w-full py-4 flex justify-between absolute bottom-0 px-4">
                              <button
                                  type={undefined}
                                  data-testid="CaseListLink"
                                  className="global-txt text-teal underline-new"
                                  onClick={callCaseListPage}
                                >
                              <b> {t("CP079")} </b>
                            
                          </button>
                      </div>
           ):  <ErrorComponent input={[getCasesList,getAssetsById, getCustomer]} />} 
      
      
          </div>
          
        )}
      </div>
    </main>
  );
};

export default CaseCard;
